import SingleStudentView from "@features/students/view/single-students-view";

const SingleStudent = () => {
  return <SingleStudentView />;
};

export default SingleStudent;
